import React from "react";
import { translations } from "../translations";
import { formatTimeTaken } from "../utils/quiz";

const ResultScreen = ({
  score,
  total,
  user,
  terminated,
  reason,
  timeTakenSeconds,
  typingTest,
  lang,
}) => {
  const t = translations[lang];
  const percentage = total > 0 ? Math.round((score / total) * 100) : 0;
  const circumference = 2 * Math.PI * 54;
  const strokeOffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="page-wrap">
      <div className="card result-card">
        {!terminated && (
          <div className="score-ring-wrap">
            <svg className="score-ring-svg" viewBox="0 0 120 120">
              <circle className="score-ring-bg" cx="60" cy="60" r="54" />
              <circle
                className="score-ring-progress"
                cx="60"
                cy="60"
                r="54"
                strokeDasharray={circumference}
                strokeDashoffset={strokeOffset}
              />
            </svg>
            <div className="score-ring-center">
              <span className="result-score-value">{score}</span>
              <span className="result-score-of">/ {total}</span>
            </div>
          </div>
        )}

        <div className={`result-icon-wrap ${terminated ? "visible" : "hidden"}`}>
          <span className="result-icon result-icon-fail">✕</span>
        </div>

        <h2 className="result-title">{t.result}</h2>

        <div className="result-user-card">
          <div className="result-avatar">{user?.fullName?.charAt(0)?.toUpperCase() || "?"}</div>
          <div>
            <p className="result-user-name">{user?.fullName || user?.name}</p>
            <p className="result-user-phone">{user?.phoneNumber || user?.email}</p>
          </div>
        </div>

        {terminated ? (
          <>
            <div className="result-status fail">
              <p className="result-status-title">{t.examTerminated}</p>
              <p className="result-reason">{t.reason}: {reason}</p>
            </div>
            {typingTest && (
              <div className="result-typing-section">
                <h3 className="result-typing-heading">{t.typingTestTitle}</h3>
                <div className="result-typing-stats">
                  <div className="result-typing-stat">
                    <span className="result-typing-value">{typingTest.wpm}</span>
                    <span className="result-typing-label">{t.typingWpm}</span>
                  </div>
                  <div className="result-typing-stat">
                    <span className="result-typing-value">{typingTest.accuracy}%</span>
                    <span className="result-typing-label">{t.typingAccuracy}</span>
                  </div>
                  <div className="result-typing-stat">
                    <span className="result-typing-value">{typingTest.totalChars}</span>
                    <span className="result-typing-label">{t.typingChars}</span>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <p className="result-percentage">{percentage}% {t.correct}</p>
            {timeTakenSeconds > 0 && (
              <div className="result-time-chip">
                <span>⏱</span> {t.timeTaken}: {formatTimeTaken(timeTakenSeconds)}
              </div>
            )}
            {typingTest && (
              <div className="result-typing-section">
                <h3 className="result-typing-heading">{t.typingTestTitle}</h3>
                <div className="result-typing-stats">
                  <div className="result-typing-stat">
                    <span className="result-typing-value">{typingTest.wpm}</span>
                    <span className="result-typing-label">{t.typingWpm}</span>
                  </div>
                  <div className="result-typing-stat">
                    <span className="result-typing-value">{typingTest.accuracy}%</span>
                    <span className="result-typing-label">{t.typingAccuracy}</span>
                  </div>
                  <div className="result-typing-stat">
                    <span className="result-typing-value">{typingTest.totalChars}</span>
                    <span className="result-typing-label">{t.typingChars}</span>
                  </div>
                </div>
              </div>
            )}
            <div className="result-status pass">
              <p className="subtitle">{t.submissionMessage}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ResultScreen;
